import ACTIONS from "../constants/actions";

const {
  GET_LEAVE_TYPE,
  GET_LEAVE_TYPE_SUCCESS,
  GET_LEAVE_TYPE_FAIL,
  GET_LEAVE_TYPE_WORKFLOW,
  GET_LEAVE_TYPE_WORKFLOW_SUCCESS,
  GET_LEAVE_TYPE_WORKFLOW_FAIL,
} = ACTIONS;

const initialState = {
  isLoadingLeaveTypes: false,
  leaveTypes: [],
  isLoadingLeaveTypeWorkflows: false,
  leaveTypeWorkflows: [],
};

const leaveTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LEAVE_TYPE:
      return {
        ...state,
        isLoadingLeaveTypes: true,
      };
    case GET_LEAVE_TYPE_SUCCESS:
      return {
        ...state,
        isLoadingLeaveTypes: false,
        leaveTypes: action.payload,
      };
    case GET_LEAVE_TYPE_FAIL:
      return {
        ...state,
        isLoadingLeaveTypes: false,
      };

    case GET_LEAVE_TYPE_WORKFLOW:
      return {
        ...state,
        isLoadingLeaveTypeWorkflows: true,
      };
    case GET_LEAVE_TYPE_WORKFLOW_SUCCESS:
      return {
        ...state,
        isLoadingLeaveTypeWorkflows: false,
        leaveTypeWorkflows: action.payload,
      };
    case GET_LEAVE_TYPE_WORKFLOW_FAIL:
      return {
        ...state,
        isLoadingLeaveTypeWorkflows: false,
      };

    default:
      return state;
  }
};
export default leaveTypeReducer;
